import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  DialogBoxWrapper,
  DialogHeader,
  ButtonsRegionWrapper,
  ContentWrapper
} from "./styles";
import Div from "../division";

/**
 * A Dialog is a type of modal window that appears in front of app content to provide critical information or ask for a decision. Dialogs disable all app functionality when they appear, and remain on screen until confirmed, dismissed, or a required action has been taken.
 * @visibleName Dialog Box
 */
export default class DialogBox extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false
    };
    this.children = null;
  }
  static dialogBoxes = [];
  static open = title => {
    let dialogBox = DialogBox.dialogBoxes.find(
      box => box.props.title === title
    );
    document.body.style.overflow = "hidden";
    dialogBox.setState({ isOpen: true });
  };
  static close = title => {
    let dialogBox = DialogBox.dialogBoxes.find(
      box => box.props.title === title
    );
    document.body.style.overflow = "visible";
    dialogBox.setState({ isOpen: false });
  };
  handleClick = () => {
    DialogBox.close(this.props.title);
  };
  componentDidMount = () => {
    DialogBox.dialogBoxes.push(this);
  };
  componentWillUnmount = () => {
    DialogBox.dialogBoxes = DialogBox.dialogBoxes.filter(
      x => x.props.title !== this.props.title
    );
  };
  render() {
    const { isOpen } = this.state;
    const { xs, sm, md, lg, title, buttons, scrollable } = this.props;
    const viewportWidth = window.innerWidth.toString();
    if (this.props.children) {
      this.children = React.cloneElement(this.props.children, {
        dialogBox: isOpen
      });
    }
    return (
      <>
      {isOpen && (<DialogBoxWrapper data-test="component-app">
        <Div
          onClick={() => this.handleClick()}
          data-test="clickable-background"
        ></Div>
        <ContentWrapper
          xs={xs}
          sm={sm}
          md={md}
          lg={lg}
          vw={viewportWidth}
          scrollable={scrollable}
          data-test="content-wrapper"
        >
          <DialogHeader data-test="dialog-header">{title}</DialogHeader>
          <Div data-test="children-component">{this.children}</Div>
          <ButtonsRegion buttons={buttons} data-test="buttons-region" />
        </ContentWrapper>
      </DialogBoxWrapper>)}
      </>
    );
  }
}
export const ButtonsRegion = ({ buttons }) => {
  return (
    <ButtonsRegionWrapper data-test="component-app">
      {buttons.map(button => {
        return button;
      })}
    </ButtonsRegionWrapper>
  );
};
DialogBox.propTypes = {
  /** Title of the Dialog */
  title: PropTypes.string,

  /** For message taller than the browser height */
  scrollable: PropTypes.bool,

  /** Array of Buttons to be displayed at the footer of the Dialog */
  buttons: PropTypes.array,

  /** Grid size for Extra Small screen */
  xs: PropTypes.string,

  /** Grid size for Small screen */
  sm: PropTypes.string,

  /** Grid size for Medium screen */
  md: PropTypes.string,

  /** Grid size for Large screen */
  lg: PropTypes.string
};
DialogBox.defaultProps = {
  title: "Title",
  scrollable: false,
  buttons: [],
  xs: "12",
  sm: "12",
  md: "12",
  lg: "12"
};
